import { useState } from 'react';
import { useAuth } from './useAuth';
import { hacerSolicitud } from '../helpers/apiClient';

const useActualizarCita = () => {
  const { renovarToken, cerrarSesion } = useAuth();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  // ✅ Función para actualizar cita
  const actualizarCita = async (
    almacenId,
    fecha,
    horaInicio,
    horaFin,
    comentariosAdAlmcn,
    comentariosAdCrr,
    url
  ) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      await hacerSolicitud(
        url,
        {
          method: 'PUT',
          body: JSON.stringify({
            almacenId,
            fecha,
            dataIni: horaInicio,
            dataFin: horaFin,
            cometariosAdAlmcn: comentariosAdAlmcn,
            cometariosAdCrr: comentariosAdCrr,
          }),
        },
        renovarToken,
        cerrarSesion
      );

      setSuccess(true);
      return true;
    } catch (err) {
      setError(err.message);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { actualizarCita, error, success, loading };
};

export default useActualizarCita;
